module.exports = __webpack_public_path__ + "static/media/x-ray.4cff896c.jpeg";